import PromotionBackground from "../../constants/assests/image/promotionBackground.png"

function PromotionImage() {
  return (
    <div className=" flex justify-center bg-gradient-to-r from-orange-600 to-blue-500 w-screen ">
        <img  src={PromotionBackground} alt="This is promotion backgrground image" />
    </div>
  )
}

export default PromotionImage
